export enum PricingControlsActionType {
  GET_FAILURE = '@@pricingControls/PRICING_CONTROLS_FAILURE',
  GET_REQUEST = '@@pricingControls/PRICING_CONTROLS_REQUEST',
  GET_SUCCESS = '@@pricingControls/PRICING_CONTROLS_SUCCESS',
}
